<app-modal [Modal]="{
    title: 'Creación de usuario',
    closeTitle: true,
    hiddenFooter: !true
}">
    <ng-container body>
        <article>
            <form [formGroup]="form">
                <mat-form-field>
                    <mat-label>Usuario ERP</mat-label>
                    <input type="text" formControlName="erpUserId" autocomplete="off" matInput placeholder="Usuario ERP" [matAutocomplete]="product">
                    <mat-autocomplete #product="matAutocomplete">
                        <mat-option *ngFor="let users of userList$ | async" (onSelectionChange)="selectUsers(users)" [value]="users.erpUserID">
                            {{users.erpUserID}} - {{users.name}}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="form.get('erpUserId')?.hasError('required')">Este campo es obligatorio</mat-error>
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Rut</mat-label>
                    <input type="text" formControlName="rut" (keyup)="onChange($event.target)" [readonly]="!ErpUser.length" autocomplete="off" matInput placeholder="Rut">
                    <mat-error *ngIf="form.get('rut')?.hasError('required')">Este campo es obligatorio</mat-error>
                    <mat-error *ngIf="form.get('rut')?.hasError('Rut inválido')">El Rut con formato incorrecto</mat-error>
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Nombre</mat-label>
                    <input type="text" formControlName="firstName" [readonly]="!ErpUser.length" autocomplete="off" matInput placeholder="Nombre">
                    <mat-error *ngIf="form.get('firstName')?.hasError('required')">Este campo es obligatorio</mat-error>
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Apellido</mat-label>
                    <input type="text" formControlName="lastName" [readonly]="!ErpUser.length" autocomplete="off" matInput placeholder="Apellido">
                    <mat-error *ngIf="form.get('lastName')?.hasError('required')">Este campo es obligatorio</mat-error>
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Correo</mat-label>
                    <input type="email" formControlName="firstEmail" [readonly]="!ErpUser.length" autocomplete="off" matInput placeholder="Correo">
                    <mat-error *ngIf="form.get('firstEmail')?.hasError('required')">Este campo es obligatorio</mat-error>
                </mat-form-field>

                <mat-form-field class="-password">
                    <mat-label>Contraseña</mat-label>
                    <input [type]="!pass ? 'password' : 'text'" [readonly]="!ErpUser.length" formControlName="password" autocomplete="off" matInput placeholder="Contraseña">
                    <mat-icon matSuffix (click)="pass = !pass">{{pass ? 'visibility_off' : 'visibility'}}</mat-icon>
                    <mat-error *ngIf="form.get('password')?.hasError('required')">Este campo es obligatorio</mat-error>
                    <mat-hint [ngClass]="hasError(1) && 'success' || 'error'">
                        <mat-icon>{{hasError(1) && 'error' || 'check_circle'}}</mat-icon>
                        La contraseña debe tener una longitud entre 10 a 50 caracteres
                    </mat-hint>
                    <mat-hint [ngClass]="hasError(2) && 'success' || 'error'">
                        <mat-icon>{{hasError(2) && 'error' || 'check_circle'}}</mat-icon>
                        La contraseña debe contener mínimo un caracter especial
                    </mat-hint>
                    <mat-hint [ngClass]="hasError(3) && 'success' || 'error'">
                        <mat-icon>{{hasError(3) && 'error' || 'check_circle'}}</mat-icon>
                        La contraseña debe contener mínimo un número
                    </mat-hint>
                    <mat-hint [ngClass]="hasError(4) && 'success' || 'error'">
                        <mat-icon>{{hasError(4) && 'error' || 'check_circle'}}</mat-icon>
                        La contraseña debe contener mínimo una letra en mayuscula
                    </mat-hint>
                    <mat-hint [ngClass]="hasError(5) && 'success' || 'error'">
                        <mat-icon>{{hasError(5) && 'error' || 'check_circle'}}</mat-icon>
                        La contraseña debe contener mínimo una letra en minuscula
                    </mat-hint>
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Correo Secundario</mat-label>
                    <input type="email" formControlName="secondEmail" [readonly]="!ErpUser.length" autocomplete="off" matInput placeholder="Correo Secundario">
                    <mat-error *ngIf="form.get('secondEmail')?.hasError('required')">Este campo es obligatorio</mat-error>
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Teléfono</mat-label>
                    <input type="tel" formControlName="phone" [readonly]="!ErpUser.length" autocomplete="off" matInput placeholder="Teléfono">
                    <mat-error *ngIf="form.get('phone')?.hasError('required')">Este campo es obligatorio</mat-error>
                </mat-form-field>

            </form>
        </article>
    </ng-container>
    <ng-container footer>
        <button class="df-primario df-btn-xl" [disabled]="onValidation" (click)="onSubmit()">
      Guardar
    </button>
    </ng-container>
</app-modal>